<script setup lang="ts">
import qrcode from "@/common/assets/support-qrcode.png"

interface IProps {
    fileDownloadLink?: string
}

const open = defineModel()
defineProps<IProps>()
</script>

<template>
    <q-dialog v-model="open">
        <q-card>
            <q-card-section class="q-my-lg text-center">
                <div v-if="fileDownloadLink">
                    <a :href="fileDownloadLink" target="_blank" style="color: deepskyblue"
                        >Руководство пользователя</a
                    >
                </div>
                <div class="q-mt-md">
                    <a href="https://t.me/StuddyBuddy_Support" target="_blank">
                        <img :src="qrcode" width="200" />
                    </a>
                </div>
                <div class="q-mt-sm">
                    <a
                        href="https://t.me/StuddyBuddy_Support"
                        target="_blank"
                        style="color: deepskyblue"
                        >Поддержка</a
                    >
                </div>
            </q-card-section>
            <q-card-actions align="center">
                <q-btn label="Закрыть" color="primary" outline @click="open = false" />
            </q-card-actions>
        </q-card>
    </q-dialog>
</template>

<style scoped>
.q-card {
    min-width: 300px;
    background: var(--q-dark);
}
</style>
